import { MutationTree } from 'vuex';
import { IUserState } from './user-state.store';
import {
  USER_INFO_RECIEVED,
  USER_INFO_STATUS,
  USER_INFO_PATCH,
  USER_INFO_FIELD,
  REVERT_USER_INFO,
  USER_ACTION,
  USER_INIT,
  USER_SET_USER_BY_FIELD,
  USER_ACTION_TYPE
} from './user-types.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
//@ts-ignore
import { IUserDetails } from '../../models/user';
import * as _ from 'lodash';
import { CrudStatus } from '../../common/enums';
import { IUser } from '../../models/user/user.model';
import { UserTemplate } from '../../common/enums';

export const mutations: MutationTree<IUserState> = {
  [USER_INFO_STATUS]: (state: IUserState, payload: ActivityStatus) => {
    state.activityStatus = payload;
  }
  , [USER_INFO_RECIEVED]: (state: IUserState, userInfo: IUserDetails) => {

    localStorage.setItem('user', JSON.stringify(userInfo))

    const modules = { home: true, reset: true, forgot: true, signUp: true, signUpConfirmation: true, verifyChanges: true }
    let navigation: any[] = ['home', 'reset', 'forgot', 'signUp', 'signUpConfirmation', 'verifyChanges'];
    let loggedInNavKey : any[] = ['ticket_list','documents','block', 'service_book', 'contact','agenda','settings_admin','profile','reception_process','vehicle_check_process','bm']

    /* if(userInfo.template === UserTemplate.default)
    {
      loggedInNavKey = ['ticket_list','documents','block', 'service_book', 'contact','agenda','settings_admin','profile','reception_process','vehicle_check_process','bm']
    }else{
      loggedInNavKey = ['service_book','documents']
    } */

    userInfo.modules.forEach(key => {
      modules[key] = true;
      if (loggedInNavKey.indexOf(key) !== -1) {
        navigation.push(key)
      }
    });

    state.modules = modules;
    state.userInfo = userInfo;

    localStorage.setItem('modules', JSON.stringify(modules));
    localStorage.setItem('navigations', JSON.stringify(navigation));

  }
  , [USER_INFO_PATCH]: (state: IUserState, userInfo: IUserDetails) => {
    state.userInfo = { ...state.userInfo, ...userInfo };
    localStorage.setItem('user', JSON.stringify(state.userInfo))
  }
  , [USER_INFO_FIELD]: (state: IUserState, userInfo: IUserDetails) => {
    state.userInfo = { ...state.userInfo, ...userInfo };
  }
  , [REVERT_USER_INFO]: (state: IUserState) => {
    state.userInfo = JSON.parse(localStorage.getItem('user')) as IUserDetails;
  }
  , [USER_ACTION] : (state : IUserState, status : CrudStatus) => {
      state.crudActionStatus = status
  }
  , [USER_ACTION_TYPE] : (state : IUserState, type : string) => {
      state.actionType = type
  }
  , [USER_INIT] : (state: IUserState, user: IUser) => {
    state.user= user
  }
  , [USER_SET_USER_BY_FIELD] : (state: IUserState, payload: IUser) => {
    state.user= {
      ...state.user,
      ...payload
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/user/user-mutations.store.ts